import React from "react";
import EditDevice from "../../../Features/Forms/Devices/Edit";

const Edit = () => {
  return (
    <div>
      <EditDevice />
    </div>
  );
};

export default Edit;
